import styled from 'styled-components';
import { ItemBox } from '../../ItemCommons';

export const CardWrapper = styled(ItemBox)<{ isTileView: boolean }>`
  display: flex;
  flex-direction: ${({ isTileView }) => (isTileView ? 'column' : 'row')};
  width: 100%;
  padding: ${({ isTileView }) => !isTileView && '8px 12px'};
`;

export const CardDescriptionWrapper = styled.div<{ isTileView: boolean }>`
  padding: ${({ isTileView }) => isTileView && '8px 12px 16px'};
  display: flex;
  flex-direction: column;
`;
